export const AUTH_AUTHENTICATE = 'auth/authenticate';
export const AUTH_AUTHENTICATE_SUCCESS = 'auth/authenticate/success';
export const AUTH_AUTHENTICATE_FAILED = 'auth/authenticate/failed';
export const AUTH_AUTHENTICATE_VIA_TOKEN = 'auth/authenticate/via-token';
export const AUTH_AUTHENTICATE_VIA_TOKEN_FAILED = 'auth/authenticate/via-token/failed';
export const AUTH_AUTHENTICATE_VIA_TOKEN_SUCCESS = 'auth/authenticate/via-token/success';
export const AUTH_AUTHENTICATE_VIA_COOKIE = 'auth/authenticate/via-cookie';
export const AUTH_AUTHENTICATE_VIA_COOKIE_FAILED = 'auth/authenticate/via-cookie/failed';
export const AUTH_AUTHENTICATE_VIA_COOKIE_SUCCESS = 'auth/authenticate/via-cookie/success';
export const AUTH_AUTHENTICATE_VIA_LOGINLESS = 'auth/authenticate/via-loginless';
export const AUTH_AUTHENTICATE_VIA_LOGINLESS_SUCCESS = 'auth/authenticate/via-loginless/success';
export const AUTH_AUTHENTICATE_VIA_LOGINLESS_FAILED = 'auth/authenticate/via-loginless/failed';
export const AUTH_LOGIN = 'auth/signin';
export const AUTH_LOGIN_FAILED = 'auth/login/failed';
export const AUTH_LOGIN_SUCCESS = 'auth/login/success';
export const AUTH_LOGOUT = 'auth/logout';
export const AUTH_LOGOUT_FAILED = 'auth/logout/failed';
export const AUTH_LOGOUT_SUCCESS = 'auth/logout/success';

export const AUTH_SET_USER = 'authuser/set_user';
